import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Card } from 'antd';
import FaIcon from '../../components/global/fa-icon/fa-icon';
import Unauthorized from '../../components/login/unauthorized';


class DashboardMainView extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {

    if (!this.props.auth.isLoggedIn) {
      return <Unauthorized />;
    }

    return (
      <div className="dashboard-main-view mx-auto">
        <Card className="px-5 pb-5">
          <h2 className="center text-center py-5">
            What would you like to do today?
          </h2>
          <div className="container">
            <div className="nav-menu row">

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/movies">
                <div className="icon"><FaIcon icon="fa-film-alt" /></div>
                <div className="label">Movies</div>
              </NavLink>

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/coming-soon">
                <div className="icon"><FaIcon icon="fa-alarm-clock" /></div>
                <div className="label">Coming Soon</div>
              </NavLink>

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/schedules">
                <div className="icon"><FaIcon icon="fa-calendar-alt" /></div>
                <div className="label">Schedules</div>
              </NavLink>

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/news">
                <div className="icon"><FaIcon icon="fa-newspaper" /></div>
                <div className="label">News</div>
              </NavLink>

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/theaters">
                <div className="icon"><FaIcon icon="fa-hotel" /></div>
                <div className="label">Theaters</div>
              </NavLink>

              <NavLink className="nav-item clickable col-sm-4 col-12" activeClassName="selected" to="/users">
                <div className="icon"><FaIcon icon="fa-user-friends" /></div>
                <div className="label">Users</div>
              </NavLink>
            </div>
          </div>
        </Card>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardMainView));

